import { automationToolActivityDescribers } from "../automation/automation-tool-activity-describers";
import { browserToolActivityDescribers } from "../browser/browser-tool-activity-describers";
import { integrationToolActivityDescribers } from "../canonical/integration-tool-activity-describers";
import { databaseToolActivityDescribers } from "../database/database-tool-activity-describers";
import { designToolActivityDescribers } from "../design/design-tool-activity-describers";
import { factoryToolActivityDescribers } from "../factory/factory-tool-activity-describers";
import { gitToolActivityDescribers } from "../git/git-tool-activity-describers";
import { interactiveViewToolActivityDescribers } from "../interactive-view/interactive-view-tool-activity-describers";
import { nativeToolActivityDescribers } from "../native/native-tool-activity-describers";
import { reviewToolActivityDescribers } from "../review/review-tool-activity-describers";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { labsToolActivityDescribers } from "../video/labs-tool-activity-describers";

export const domainToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  ...integrationToolActivityDescribers,
  ...browserToolActivityDescribers,
  ...designToolActivityDescribers,
  ...labsToolActivityDescribers,
  ...automationToolActivityDescribers,
  ...reviewToolActivityDescribers,
  ...databaseToolActivityDescribers,
  ...factoryToolActivityDescribers,
  ...interactiveViewToolActivityDescribers,
  ...gitToolActivityDescribers,
  ...nativeToolActivityDescribers,
];
